import {
    Button,
    Paper,
    Grid,
    TextField,
    Select,
    Checkbox,
    FormGroup,
    FormControlLabel,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Typography,
    Tab,
    Tabs,
    Tooltip
} from "@material-ui/core";
import * as React from "react";
import { observable, action, computed, toJS, autorun } from "mobx";
import { createStyles, withStyles } from "@material-ui/core/styles";
import { config } from "src/config";

import { authStore } from "src/modules/auth";
import { observer } from "mobx-react";
import { companiesAdminStore } from "src/modules/admin/modules/CompaniesAdmin";
import { Loading } from "src/components/loading";
import { history } from "src/history.js";
import { withRouter } from "react-router";
import { validationsStore } from '../../../../validations';

const styles = createStyles({
    root: {
        width: "100%",
        height: "100%",
        margin: "0 auto",
        // padding: "1.5rem",
        display: "flex",
        flexDirection: "column",
    },
    rowContainer: {
        width: "100%",
        display: "flex",
        alignContent: "center",
        margin: "0 auto",
        // padding: "3rem",
    },
    columnContainer: {
        width: "100%",
        display: "flex",
        margin: "0 auto",
        // padding: "3rem",
    },
    textField: {
        display: "flex",
        paddingRight: "24px",
    },
    roleSelect: {
        minWidth: "9rem",
    },
    companySelect: {
        minWidth: "16.5rem",
    },
    appRoleSelect: {
        minWidth: "16.5rem",
        paddingTop: "1.5rem",
    },
    formContainer: {
        width: "100%",
        padding: "1.5rem",
    },
    submitContainer: {
        width: "100%",
        display: "flex",
        flexDirection: "row-reverse",
    },
    submitButton: {
        // backgroundColor: "#2A2A55",
        // border: "1px solid #2D4D73",
        // color: "#FAFAFA",
    },
});

@observer
class CompaniesForm extends React.Component<any> {

    public render() {
        // D-011
        let distributorOption:any = [
            {label: "Pharmacy", value: ''},
            {label: "Distributor", value: 'distributor'},
        ]
        const { classes, mode, currentCompany } = this.props;

        return (
            <Grid container={true} direction="column">
                <Grid
                    container={true}
                    direction="row"
                    classes={{ container: classes.rowContainer }}
                    spacing={8}
                >
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Name"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyName}
                            InputLabelProps={{ shrink: true }}
                            required={true}
                            onChange={this.handleInput("CompanyName")}
                            error={!validationsStore.validator["CompanyName"].valid}
                            helperText={
                                !validationsStore.validator["CompanyName"].valid
                                    ? validationsStore.validator["CompanyName"].errorMessage.join()
                                    : " "
                            }
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Description"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyDescription}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyDescription")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Address"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyAddress}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyAddress")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company City"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyCity}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyCity")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company State"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyState}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyState")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Zip"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyZip}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyZip")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Phone"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyPhone}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyPhone")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Email"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyEmail}
                            InputLabelProps={{ shrink: true }}
                            required={true}
                            onChange={this.handleInput("CompanyEmail")}
                            error={!validationsStore.validator["CompanyEmail"].valid}
                            helperText={
                                !validationsStore.validator["CompanyEmail"].valid
                                    ? validationsStore.validator["CompanyEmail"].errorMessage.join()
                                    : " "
                            }
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Web Address"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyWebAddress}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyWebAddress")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Billing Contact Name"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyBillingContactName}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyBillingContactName")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Billing Contact Phone"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyBillingContactPhone}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyBillingContactPhone")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}>
                        <TextField
                            label="Company Billing Contact Email"
                            classes={{ root: classes.textField }}
                            value={this.props.currentCompany.CompanyBillingContactEmail}
                            InputLabelProps={{ shrink: true }}
                            // required={true}
                            onChange={this.handleInput("CompanyBillingContactEmail")}
                            disabled={this.props.match.params.view_type === 'detail'}
                        />
                    </Grid>
                    <Grid item={true} xs={6}> 
                        {/* D-011*/}
                        <FormControl>
                        <InputLabel htmlFor={"portal_role"} shrink={true}>
                            Company Business Type
                        </InputLabel>
                        <Select
                            inputProps={{ shrink: true  }}
                            value={this.props.currentCompany.CompanyBusinessType}
                            classes={{ root: classes.companySelect }} //D-011
                            // tslint:disable-next-line: jsx-no-lambda
                            onChange={this.addDistributorType()}
                            disabled={this.props.match.params.view_type === 'detail'}
                            >
                                {distributorOption?.map((item, index)=>(
                                <MenuItem key={index} value={item.value}>
                                    {item.label}
                                </MenuItem>
                                ))}
                        </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
    @action
    protected handleInput = (property: string) => (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        this.props.currentCompany[property] = e.target.value;
        validationsStore.runValidator(property, this.props.currentCompany[property] = e.target.value)
    };

    // D-011 new
    @action
    @action
    protected addDistributorType = () => (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        this.props.currentCompany.CompanyBusinessType = e.target.value
    };
}

export default withStyles(styles, { withTheme: true })(
    withRouter(CompaniesForm)
);


// WEBPACK FOOTER //
// ./src/modules/admin/modules/CompaniesAdmin/components/CompaniesForm.tsx